// AHA-47221: a sync dispatch is either the status on its own — 1 saving, 2 saved, 3 failed — or
// `{ status, from }`: the same status plus a label saying WHICH save it is, for subscribers that
// need to tell one from another (see PptEditorMixin). Only the status ever reaches the store —
// state.isSyncing is a number the whole editor compares against 1/2/3 — so this is where the two
// shapes become one again.
export const syncStatusOf = (payload) => {
  if (payload && typeof payload === 'object') return payload.status
  return payload
}

const setSyncLoadingAction = ({ commit }, payload) => {
  commit('setSyncLoading', syncStatusOf(payload))
}

export default {
  setSyncLoadingAction,
}
